<script type="text/ecmascript-6">
    import Layout from '../layouts/MainLayout.vue'
    import {mapGetters} from "vuex";
    import DateRange from "../components/DateRange";
    import TopHeader from "../components/TopHeader";
    import Modal from "../components/modal";

    export default {
        components: {DateRange, Layout, Modal, TopHeader},

        /**
         * The component's data.
         */
        data: () => ({
            showModal: false,
            type: null,
            value: null,
            percent: null,
            modalTitle: '',
            dateRange: {
                startDate: '2019-12-10',
                endDate: '2019-12-20',
            },
        }),

        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                isLoading: 'getIsLoading',
                isShow: 'getIsShow',
                dateTime: 'getDateTime',
                ownPageData: 'getOwnPageData',
                isPreview: 'getIsPreview',
            })
        },

        methods: {
            formSubmit() {
                this.$store.dispatch(this.type,{value: this.value, percent: this.percent});
                this.showModal = false;
            },

            clickModal(type, value, percent) {
                switch(type) {
                    case 'updateBudgetSpend':
                        this.modalTitle = 'Budget Spend';
                        break;

                    case 'updateCPM':
                        this.modalTitle = 'CPM';
                        break;

                    case 'updateCPA':
                        this.modalTitle = 'CPA';
                        break;

                    case 'updateCTR':
                        this.modalTitle = 'CTR';
                        break;

                    default:
                    this.modalTitle = 'Header';
                }

                this.type = type;
                this.value = value;
                this.percent = percent;
                this.showModal = true;
            }
        }
    }
</script>

<template>
    <layout>
        <div :class="{'container-fluid' : !isPreview }" v-show="!isLoading">
            <date-range></date-range>

            <div class="card" :class="[{'mb-3': !isPreview}, {'border-0': isPreview}]" v-show="isShow">
                <div class="card-body">
                    <!-- Content Row -->
                    <top-header name="Social Media Report"></top-header>

                    <div class="row pt-5">
                        <div class="col-md-2">
                            <h3 class="text-black">EXECUTIVE SUMMARY</h3>
                        </div>
                        <div class="col-md-10">
                            <p class="text-black">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad deleniti dolor doloribus dolorum eaque eligendi expedita hic ipsa laborum maxime minima, nisi numquam omnis, quo quos reprehenderit sequi temporibus tenetur?Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad deleniti dolor doloribus dolorum eaque eligendi expedita hic ipsa laborum maxime minima, nisi numquam omnis, quo quos reprehenderit sequi temporibus tenetur? Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad deleniti dolor doloribus dolorum eaque eligendi expedita hic ipsa laborum maxime minima, nisi numquam omnis, quo quos reprehenderit sequi temporibus tenetur?</p>
                            <p class="text-black">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad deleniti dolor doloribus dolorum eaque eligendi expedita hic ipsa laborum maxime minima, nisi numquam omnis, quo quos reprehenderit sequi temporibus tenetur?</p>
                            <div class="d-flex flex-row float-right">
                                <div>
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcR-LKdAKV-n7M78CN_aHHKPmtoF7sbU0vXbKHvITojSAFQRXCYj" width="100" alt="">
                                </div>
                                <div class="pl-3 mt-auto mb-auto">
                                    <h5 class="text-black">Jordan Belford | Account Manger</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3 border-top border-bottom">
                        <div class="col-4 pt-5 border-right">
                            <h5 class="text-black pb-3 font-weight-bolder text-uppercase">engagement</h5>
                            <div class="d-flex flex-row">
                                <div>
                                    <h1 class="text-black font-weight-bolder"> {{ ownPageData.engagement.value }}+</h1>
                                </div>
                                <div class="pl-4 mt-auto mb-auto">
                                    <template v-if="ownPageData.engagement.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.engagement.percent }}%</h5>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-down text-warning pr-2"></i>
                                        <h5 class="text-warning d-inline">{{ ownPageData.engagement.percent }}%</h5>
                                    </template>
                                </div>
                            </div>

                            <h5 class="text-black pt-5 pb-3 font-weight-bolder text-uppercase">engagement rate</h5>
                            <div class="d-flex flex-row">
                                <div>
                                    <h1 class="text-black font-weight-bolder">{{ ownPageData.engagement_rate.value }}%</h1>
                                </div>
                                <div class="pl-4 mt-auto mb-auto">
                                    <template v-if="ownPageData.engagement_rate.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.engagement_rate.percent }}%</h5>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-down text-warning pr-2"></i>
                                        <h5 class="text-warning d-inline">{{ ownPageData.engagement_rate.percent }}%</h5>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-4 pt-5 pl-5 pb-5">
                            <div class="d-flex flex-row">
                                <div>
                                    <i class="far fa-comment-alt fa-2x d-block text-black pb-4"></i>
                                </div>
                                <div class="pl-3">
                                    <h5 class="text-black font-weight-bolder">{{ numberFormat(ownPageData.comments.value) }}</h5>
                                    <h6 class="text-black">Comments</h6>
                                </div>
                                <div class="pl-3 pt-1">
                                    <template v-if="ownPageData.comments.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.comments.percent }}%</h5>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.comments.percent }}%</h5>
                                    </template>
                                </div>
                            </div>
                            <div class="d-flex flex-row pt-4">
                                <div>
                                    <i class="fa fa-retweet fa-2x d-block text-black pb-4"></i>
                                </div>
                                <div class="pl-3">
                                    <h5 class="text-black font-weight-bolder">{{ numberFormat(ownPageData.share.value) }}</h5>
                                    <h6 class="text-black">Share</h6>
                                </div>
                                <div class="pl-3 pt-1">
                                    <template v-if="ownPageData.share.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.share.percent }}%</h5>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.share.percent }}%</h5>
                                    </template>
                                </div>
                            </div>

                            <div class="d-flex flex-row pt-4">
                                <div>
                                    <i class="far fa-heart fa-2x d-block text-black pb-4"></i>
                                </div>
                                <div class="pl-3">
                                    <h5 class="text-black font-weight-bolder">{{ numberFormat(ownPageData.reactions.value) }}</h5>
                                    <h6 class="text-black">Reactions</h6>
                                </div>
                                <div class="pl-3 pt-1">
                                    <template v-if="ownPageData.reactions.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.reactions.percent }}%</h5>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.reactions.percent }}%</h5>
                                    </template>
                                </div>
                            </div>

                            <div class="d-flex flex-row pt-4">
                                <div>
                                    <i class="far fa-envelope fa-2x d-block text-black pb-4"></i>
                                </div>
                                <div class="pl-3">
                                    <h5 class="text-black font-weight-bolder">{{ numberFormat(ownPageData.messages.value) }}</h5>
                                    <h6 class="text-black">Messages</h6>
                                </div>
                                <div class="pl-3 pt-1">
                                    <template v-if="ownPageData.messages.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.messages.percent }}%</h5>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.messages.percent }}%</h5>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-4 pt-5">
                            <h5 class="text-black text-uppercase">engaged users by fans</h5>
                        </div>
                    </div>

                    <div class="row border-bottom">
                        <div class="col-4 pt-5 border-right">
                            <h5 class="text-black pb-3 font-weight-bolder text-uppercase">reach</h5>
                            <div class="d-flex flex-row">
                                <div>
                                    <h1 class="text-black font-weight-bolder">{{ ownPageData.reach.value }}+</h1>
                                </div>
                                <div class="pl-4 mt-auto mb-auto">
                                    <template v-if="ownPageData.reach.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.reach.percent }}%</h5>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.reach.percent }}%</h5>
                                    </template>
                                </div>
                            </div>

                            <h5 class="text-black pt-5 pb-3 font-weight-bolder text-uppercase">impression</h5>
                            <div class="d-flex flex-row">
                                <div>
                                    <h1 class="text-black font-weight-bolder">{{ ownPageData.impression.value }}%</h1>
                                </div>
                                <div class="pl-4 mt-auto mb-auto">
                                    <template v-if="ownPageData.impression.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ ownPageData.impression.percent }}%</h5>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-down text-warning pr-2"></i>
                                        <h5 class="text-warning d-inline">{{ ownPageData.impression.percent }}%</h5>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-4 pt-5 pl-5 pb-5">
                            <div class="d-flex flex-row">
                                <div>
                                    <i class="fa fa-bolt fa-2x d-block text-black pb-4"></i>
                                </div>
                                <div class="pl-3">
                                    <h5 class="text-black font-weight-bolder">{{ numberFormat(ownPageData.paid_reach.value) }}</h5>
                                    <h6 class="text-black">Paid Reach</h6>
                                </div>
                                <div>
                                    <template v-if="ownPageData.paid_reach.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-1"></i>
                                        <h6 class="text-success d-inline">{{ ownPageData.paid_reach.percent }}%</h6>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-up text-success pr-1"></i>
                                        <h6 class="text-success d-inline">{{ ownPageData.paid_reach.percent }}%</h6>
                                    </template>
                                </div>
                            </div>

                            <div class="d-flex flex-row pt-4">
                                <div>
                                    <i class="far fa-clock fa-2x d-block text-black pb-4"></i>
                                </div>
                                <div class="pl-3">
                                    <h5 class="text-black font-weight-bolder">{{ numberFormat(ownPageData.organic_reach.value) }}</h5>
                                    <h6 class="text-black">Organic Reach</h6>
                                </div>
                                <div>
                                    <template v-if="ownPageData.organic_reach.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-1"></i>
                                        <h6 class="text-success d-inline">{{ ownPageData.organic_reach.percent }}%</h6>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-up text-success pr-1"></i>
                                        <h6 class="text-success d-inline">{{ ownPageData.organic_reach.percent }}%</h6>
                                    </template>
                                </div>
                            </div>

                            <div class="d-flex flex-row pt-4">
                                <div>
                                    <i class="fa fa-sync-alt fa-2x d-block text-black pb-4"></i>
                                </div>
                                <div class="pl-3">
                                    <h5 class="text-black font-weight-bolder">{{ ownPageData.avg_response_time.value }} min</h5>
                                    <h6 class="text-black">Average Response Time</h6>
                                </div>
                                <div class="pt-1">
                                    <template v-if="ownPageData.organic_reach.percent > 0">
                                        <i class="fas fa-caret-up text-success pr-1"></i>
                                        <h6 class="text-success d-inline">{{ ownPageData.avg_response_time.percent }}min</h6>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-up text-success pr-1"></i>
                                        <h6 class="text-success d-inline">{{ ownPageData.avg_response_time.percent }}min</h6>
                                    </template>
                                </div>
                            </div>

                        </div>
                        <div class="col-4 pt-5">
                            <h5 class="text-black text-uppercase">regional penetration</h5>
                        </div>
                    </div>

                    <div class="row border-bottom">
                        <div class="col-7 pt-5 border-right">
                            <div class="d-flex flex-row">
                                <div class="flex-fill" @click="clickModal('updateBudgetSpend', ownPageData.budget_spend.value, ownPageData.budget_spend.percent)">
                                    <h3 class="text-black pb-3 font-weight-bolder text-uppercase">budget spent</h3>
                                    <div class="d-flex flex-row">
                                        <div>
                                            <h1 class="text-black">$ {{ ownPageData.budget_spend.value }}.<span style="font-size: 12px">00</span></h1>
                                        </div>
                                        <div class="pl-4 mt-auto">
                                            <p>{{ ownPageData.budget_spend.percent }}% Changed</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-fill">
                                    <h3 class="text-black pb-3 font-weight-bolder text-uppercase">fans growth</h3>
                                    <div class="d-flex flex-row">
                                        <div>
                                            <h1 class="text-black"> {{ ownPageData.fans_growth.value }}</h1>
                                        </div>
                                        <div class="pl-4 mt-auto mb-auto">
                                            <div>
                                                <i class="fas fa-caret-up text-success pr-2"></i>
                                                <h6 class="text-success d-inline">{{ numberFormat(ownPageData.fans_growth.diff) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex flex-row">
                                <div class="d-flex flex-row flex-fill pt-5 pb-5" @click="clickModal('updateCPM', ownPageData.cpm.value, ownPageData.cpm.diff)">
                                    <div>
                                        <i class="fab fa-think-peaks fa-3x text-black"></i>
                                    </div>
                                    <div class="pl-4 mt-auto mb-auto">
                                        <h1 class="text-black font-weight-bolder">${{ ownPageData.cpm.value }}</h1>
                                        <h4 class="text-black">CPM (Average)</h4>
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ numberFormat(ownPageData.cpm.diff) }}</h5>
                                    </div>
                                </div>
                                <div class="d-flex flex-row flex-fill pt-5 pb-5" @click="clickModal('updateCPA', ownPageData.cpa.value, ownPageData.cpa.diff)">
                                    <div>
                                        <i class="far fa-thumbs-up fa-3x text-black"></i>
                                    </div>
                                    <div class="pl-4 mt-auto mb-auto">
                                        <h1 class="text-black font-weight-bolder">${{ ownPageData.cpa.value }}</h1>
                                        <h4 class="text-black">CPA (Average)</h4>
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ numberFormat(ownPageData.cpa.diff) }}</h5>
                                    </div>
                                </div>
                                <div class="d-flex flex-row flex-fill pt-5 pb-5" @click="clickModal('updateCTR', ownPageData.ctr.value, ownPageData.ctr.diff)">
                                    <div>
                                        <i class="fa fa-paper-plane fa-3x text-black"></i>
                                    </div>
                                    <div class="pl-4 mt-auto mb-auto">
                                        <h1 class="text-black font-weight-bolder">{{ ownPageData.ctr.value }}%</h1>
                                        <h4 class="text-black">CTR (Average)</h4>
                                        <i class="fas fa-caret-up text-success pr-2"></i>
                                        <h5 class="text-success d-inline">{{ numberFormat(ownPageData.ctr.diff) }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5 pt-5 pb-4">
                            <h5 class="text-black text-uppercase">audience profile</h5>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <modal v-if="showModal" @close="showModal = false">
            <h3 slot="header">{{ modalTitle }}</h3>
            <form action="/" @submit.prevent="formSubmit" slot="body">
                <div class="form-group">
                    <label for="value">Value</label>
                    <input class="form-control" type="text" id="value" name="value" v-model="value">
                </div>
                <div class="form-group">
                    <label for="percent">{{ type === 'updateBudgetSpend' ? 'Percent' : 'Different'}}</label>
                    <input class="form-control" type="text" id="percent" name="percent" v-model="percent">
                </div>
                <button type="submit" class="btn btn-success float-right">Save</button>
            </form>
        </modal>
    </layout>
</template>
